// extracted by mini-css-extract-plugin
export default {"container":"MediaCursor_container__OGVKG","title":"MediaCursor_title__Uqe6A","cursor":"MediaCursor_cursor__Mxgb7"};